// removed by extract-text-webpack-plugin
module.exports = {"helpBox":"style__helpBox__C0tic","loginContainer":"style__loginContainer__1B2C-","login":"style__login__WU95b","info":"style__info__1RHwN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/password/style.scss
// module id = 472
// module chunks = 0